import { render, staticRenderFns } from "./AddDepartmentConfig.vue?vue&type=template&id=370c7b9c&scoped=true"
import script from "./AddDepartmentConfig.vue?vue&type=script&lang=js"
export * from "./AddDepartmentConfig.vue?vue&type=script&lang=js"
import style0 from "./AddDepartmentConfig.vue?vue&type=style&index=0&id=370c7b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370c7b9c",
  null
  
)

export default component.exports